// The redirect is only a UX signal. A connected account is established solely
// by the authenticated server reconciliation, never by this browser value.
const prefix = 'poneva.connection-return.';

export type ConnectionReturnOutcome = 'complete' | 'failed';

export function connectionAttemptId() {
  return crypto.randomUUID();
}

export function recordConnectionReturn(attempt: string, outcome: ConnectionReturnOutcome) {
  if (!/^[0-9a-f-]{36}$/i.test(attempt)) return;
  try {
    localStorage.setItem(prefix + attempt, JSON.stringify({ outcome, at: Date.now() }));
  } catch {
    // The opener still checks the credential plane when storage is unavailable.
  }
}

export function readConnectionReturn(attempt: string, startedAt: number) {
  try {
    const key = prefix + attempt;
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const value = JSON.parse(raw);
    if (value.at < startedAt || !['complete', 'failed'].includes(value.outcome)) return null;
    localStorage.removeItem(key);
    return value.outcome as ConnectionReturnOutcome;
  } catch {
    return null;
  }
}
